"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DataType_1 = __importDefault(require("./interfaces/DataType"));
var FunctionName_1 = __importDefault(require("./interfaces/FunctionName"));
var FunctionUtils = /** @class */ (function () {
    function FunctionUtils() {
    }
    FunctionUtils.isDate = function (functionName) {
        switch (functionName) {
            case FunctionName_1.default.BY_CENTURY:
            case FunctionName_1.default.BY_DECADE:
            case FunctionName_1.default.BY_MILLENIUM:
            case FunctionName_1.default.BY_MILLISECOND:
            case FunctionName_1.default.BY_MINUTE:
            case FunctionName_1.default.BY_SECOND:
            case FunctionName_1.default.DAILY:
            case FunctionName_1.default.HOURLY:
            case FunctionName_1.default.MONTHLY:
            case FunctionName_1.default.QUARTERLY:
            case FunctionName_1.default.WEEKLY:
            case FunctionName_1.default.YEARLY:
                return true;
            default:
                return false;
        }
    };
    FunctionUtils.isNumber = function (functionName) {
        switch (functionName) {
            case FunctionName_1.default.COUNT:
            case FunctionName_1.default.SUM:
            case FunctionName_1.default.AVG:
            case FunctionName_1.default.VARIANCE:
            case FunctionName_1.default.STDDEV:
            case FunctionName_1.default.MIN:
            case FunctionName_1.default.MAX:
                return true;
            default:
                return false;
        }
    };
    FunctionUtils.getFunctions = function (dataType) {
        switch (dataType) {
            case DataType_1.default.DATE:
                return [
                    FunctionName_1.default.DAILY,
                    FunctionName_1.default.WEEKLY,
                    FunctionName_1.default.MONTHLY,
                    FunctionName_1.default.QUARTERLY,
                    FunctionName_1.default.YEARLY,
                    FunctionName_1.default.BY_DECADE,
                    FunctionName_1.default.BY_CENTURY,
                    FunctionName_1.default.BY_MILLENIUM,
                    FunctionName_1.default.COUNT,
                    FunctionName_1.default.COUNT_DISTINCT,
                    FunctionName_1.default.NONE
                ];
            case DataType_1.default.TIMESTAMP:
            case DataType_1.default.TIMESTAMPWITHTIMEZONE:
            case DataType_1.default.DATETIME:
                return [
                    FunctionName_1.default.BY_MILLISECOND,
                    FunctionName_1.default.BY_SECOND,
                    FunctionName_1.default.BY_MINUTE,
                    FunctionName_1.default.DAILY,
                    FunctionName_1.default.WEEKLY,
                    FunctionName_1.default.HOURLY,
                    FunctionName_1.default.MONTHLY,
                    FunctionName_1.default.QUARTERLY,
                    FunctionName_1.default.YEARLY,
                    FunctionName_1.default.BY_DECADE,
                    FunctionName_1.default.BY_CENTURY,
                    FunctionName_1.default.BY_MILLENIUM,
                    FunctionName_1.default.COUNT,
                    FunctionName_1.default.COUNT_DISTINCT,
                    FunctionName_1.default.NONE
                ];
            case DataType_1.default.TIME:
            case DataType_1.default.TIMEWITHTIMEZONE:
                return [
                    FunctionName_1.default.BY_MILLISECOND,
                    FunctionName_1.default.BY_SECOND,
                    FunctionName_1.default.BY_MINUTE,
                    FunctionName_1.default.HOURLY,
                    FunctionName_1.default.COUNT,
                    FunctionName_1.default.COUNT_DISTINCT,
                    FunctionName_1.default.NONE
                ];
            case DataType_1.default.NUMBER:
                return [
                    FunctionName_1.default.SUM,
                    FunctionName_1.default.AVG,
                    FunctionName_1.default.VARIANCE,
                    FunctionName_1.default.STDDEV,
                    FunctionName_1.default.MIN,
                    FunctionName_1.default.MAX,
                    FunctionName_1.default.COUNT,
                    FunctionName_1.default.COUNT_DISTINCT,
                    FunctionName_1.default.NONE
                ];
            default:
                return [
                    FunctionName_1.default.COUNT,
                    FunctionName_1.default.COUNT_DISTINCT,
                    FunctionName_1.default.NONE
                ];
        }
    };
    return FunctionUtils;
}());
exports.default = FunctionUtils;
//# sourceMappingURL=FunctionUtils.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/FunctionUtils.js
// module id = 1619
// module chunks = 8